<template>
  <form
    @submit.prevent="onSubmit"
    v-bind="$attrs"
    :autocomplete="autocomplete ? undefined : 'off'"
    class="app-form"
  >
    <input
      v-if="!autocomplete"
      autocomplete="off"
      type="text"
      style="display: none"
    />

    <fieldset :disabled="disabled">
      <slot />
    </fieldset>
  </form>
</template>

<script>
export default {
  name: 'AppForm',

  emits: ['submit'],

  data() {
    return {
      disable: false,
    }
  },

  props: {
    autocomplete: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    disabled() {
      return this.$attrs.disabled ?? this.$attrs.disable ?? this.disable
    },
  },

  methods: {
    setDisabled(value) {
      this.disable = value
    },

    onSubmit() {
      if (this.disabled === true) return

      this.$emit('submit', this)
    },

    reset() {
      return this.$el.reset()
    },
  },
}
</script>

<style lang="scss" scoped>
.app-form {
  width: 100%;

  > fieldset {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1;

    &:has(> .app-fieldset) {
      gap: 2rem;
    }
  }
}
</style>
s
